<template>
  <div class="device-info-boxes">
    <hamv-info-box :title="$t('deviceInfoBoxesTitleDevicesText')" :total="numberOfDevices" classes="fa fa-lightbulb-o" ></hamv-info-box>
    <hamv-info-box :title="$t('deviceInfoBoxesTitleOnlineText')" :total="numberOfConnection" classes="fa fa-wifi"></hamv-info-box>
  </div>
</template>

<script>
  import main from './DeviceInfoBoxes.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './DeviceInfoBoxes.scss';
</style>



// WEBPACK FOOTER //
// DeviceInfoBoxes.vue?637a679e